import { observer } from 'mobx-react'
import React, { Component } from "react"

@observer
export default class TopLeftMenu extends Component {

    render() {
        const { openMapLibrary, createNewMap, currentMap } = this.props
        return (
            <div className={"topMenu left"}>
                <button onClick={createNewMap}>
                    <i className="fa fa-file"></i>
                    &nbsp; New
                </button>
                <button onClick={openMapLibrary}>
                    <i className="fa fa-folder-open-o"></i>
                    &nbsp; Open
                </button>
                <p className="mapName"> 
                    { currentMap.name }
                    { currentMap.locked && <span><br/>[LOCKED] </span>}
                </p>
                <p className="info">
                    Info:
                    <br/>
                    Click the map to add or edit units.
                    <br/>
                    Drag the map with your mouse or use the scroll-wheel to zoom.
                </p>
            </div>
        )

    }

}


// WEBPACK FOOTER //
// ./src/components/TopLeftMenu.js